<template>
  <div class="sms-base-setting-box">
    <div class="sms-base-setting" v-if="!alignRight">
      <div class="teas-header-check" :class="{ 'teas-header-check-true': !isRightNowSend }" @click="handleSend(false)">
        <i v-show="!isRightNowSend" class="el-icon-check"></i>
      </div>
      <div class="teas-header-text">定时发送</div>
      <div class="teas-header-text" v-if="showRepeatSend">
        <el-switch v-model="isRepeatSend" @change="changeRepeatSend" v-show="!isRightNowSend" inactive-color="#e6e6e6" active-text="重复发送">
        </el-switch>
      </div>
      <div class="teas-header-timer" v-if="!isRightNowSend && !isRepeatSend">
        <el-date-picker v-model="sendDate" v-show="!isRightNowSend && !isRepeatSend" type="datetime" placeholder="请选择"> </el-date-picker>
      </div>
      <div class="teas-header-text repeat-time-setting" v-if="!isRightNowSend && isRepeatSend">
        <dsf-button @click="setRepeatTime" btnStyle="icon-text" type="plain" title="设置重复时间" text="" icon="shijian2"></dsf-button>
      </div>
    </div>
    <div class="sms-base-setting" v-else>
      <div class="teas-header-timer" v-if="!isRightNowSend && !isRepeatSend">
        <el-date-picker v-model="sendDate" v-show="!isRightNowSend && !isRepeatSend" type="datetime" placeholder="请选择"> </el-date-picker>
      </div>
      <div class="teas-header-text repeat-time-setting" v-if="!isRightNowSend && isRepeatSend">
        <dsf-button @click="setRepeatTime" btnStyle="icon-text" type="plain" title="设置重复时间" text="" icon="shijian2"></dsf-button>
      </div>
      <div class="teas-header-text" v-if="showRepeatSend">
        <el-switch v-model="isRepeatSend" @change="changeRepeatSend" v-show="!isRightNowSend" inactive-color="#e6e6e6" active-text="重复发送">
        </el-switch>
      </div>
      <div class="teas-header-check" :class="{ 'teas-header-check-true': !isRightNowSend }" @click="handleSend(false)">
        <i v-show="!isRightNowSend" class="el-icon-check"></i>
      </div>
      <div class="teas-header-text">定时发送</div>
    </div>
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfPlatformTeasSendFixedTime",
  ctrlCaption: "短信定时发送",
  mixins: [$mixins.control],
  props: {
    //是否开启定时重复发送
    showRepeatSend: {
      type: Boolean,
      default: false,
    },
    //是否靠右对齐
    alignRight: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isRepeatSend: false,
      isRightNowSend: true, // 是否为定时发送
      sendDate: "", // 发送日期
      cronExpression: "", //重复时间表达式
    };
  },
  computed: {},
  created() {},
  methods: {
    setRepeatTime() {
      var self = this;
      this.$openDialog({
        title: "设置重复发送时间",
        content: "DsfRepeatSendSetting",
        width: "50vw",
        height: "650px",
        overflow: "hidden auto",
        params: {
          cronExpression: this.cronExpression,
        },
        btns: [
          {
            text: "确定",
            handler(res) {
              let data = res?.yes();
              self.cronExpression = data;
            },
          },
          {
            text: "还原",
            handler(res) {
              res.clearCron();
              let data = res?.yes();
              // console.log("还原", data);
              return false;
            },
          },
          {
            text: "取消",
          },
        ],
      });
    },
    changeRepeatSend(val) {
      this.isRepeatSend = val;
    },
    // 切换发送方式
    handleSend() {
      this.isRightNowSend = !this.isRightNowSend;
    },
  },
});
</script>
